import { css } from '@/styled-system/css';

export const hdpSatelliteWrapper = css({
  marginTop: '8px !important',
  paddingTop: '0',
  paddingRight: '1x',
  paddingBottom: '0',
  paddingLeft: '1x',
  md: {
    paddingTop: '0',
    paddingRight: '2x',
    paddingBottom: '0',
    paddingLeft: '2x',
  },
});
